import React from "react";
import "../checkbox/checkbox.css";

function Checkbox(props) {
  const { title, onChange, name, value } = props;

  return (
    <div className="checkbox">
      <input
        id="check"
        type="checkbox"
        name={name}
        value={value}
        onChange={onChange}
      />
      <label>{title}</label>
    </div>
  );
}

export default Checkbox;
